import { render, staticRenderFns } from "./bindCertificate.vue?vue&type=template&id=68395837&scoped=true&"
import script from "./bindCertificate.vue?vue&type=script&lang=js&"
export * from "./bindCertificate.vue?vue&type=script&lang=js&"
import style0 from "./bindCertificate.vue?vue&type=style&index=0&id=68395837&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68395837",
  null
  
)

export default component.exports